import { REACT_APP__API_HOST } from "./env";

export const API_URL = REACT_APP__API_HOST;
